import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: import.meta.env.MODE === 'production' ? 0.2 : 1.0,
  environment: import.meta.env.MODE === 'production' ? 'production' : 'development',
  ignoreErrors: [
    // Third-party noise (AdSense/SODAR rejecting promises with no reason, esp. on iOS Safari)
    /Non-Error promise rejection captured/,
  ],
  denyUrls: [
    /googlesyndication\.com/,
    /adtrafficquality\.google/,
    /doubleclick\.net/,
  ],
});

const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(
    <Sentry.ErrorBoundary
      fallback={<p>An error occurred. Please refresh.</p>}
      onError={(error) => {
        if (import.meta.env.MODE !== 'production') {
          console.log("ErrorBoundary caught:", error);
        }
      }}
    >
    <StrictMode>
      <App />
    </StrictMode>
    </Sentry.ErrorBoundary>
  );
} else {
  if (import.meta.env.MODE !== 'production') {
    console.error('Root element not found');
  }
}
